module.exports = __webpack_public_path__ + "static/img/news-15.fa2d042.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/news-15.jpg
// module id = cum0
// module chunks = 5